/**
 * Agency label for admin dropdowns: "Agency Name (agencyId)".
 */
export function formatAgencyDropdownLabel(agency) {
  const id = String(agency?.id ?? '').trim()
  const name = String(agency?.name ?? '').trim()
  const displayName = name || id
  if (!id) return displayName
  return `${displayName} (${id})`
}
